import { useDynamicParams } from '@/data/hook/useDynamicParams';
import { getNumberParam } from '@/utils/filters/searchParams';

export const FIRST_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

type PaginationParams = {
  page: number;
};

export default function usePagination(pageSize = DEFAULT_PAGE_SIZE) {
  const { params, updateParams } = useDynamicParams<PaginationParams>();

  const pageNumber = getNumberParam(params, 'page') || FIRST_PAGE;

  const setPageNumber = (page: number) => updateParams({ page });

  return { pageNumber, pageSize, firstPage: FIRST_PAGE, setPageNumber };
}
